// Anker Cart Simple - Safe Version with DOM Ready Check (v3 - Price Fix)

(function() {

  'use strict';
  // ===== AEMAI Cart i18n =====
  var CART_TXT = {
    'pl': {
      'cartTitle': 'Koszyk zakupowy',
      'closeCart': 'Zamknij koszyk',
      'haveDiscount': 'Masz kod rabatowy?',
      'applyCode': 'Zastosuj kod',
      'enterDiscount': 'Wprowadź kod rabatowy',
      'recommended': 'Zalecane dla Ciebie',
      'shopConfidence': 'Kupuj z pewnością',
      'fastFreeShipping': 'Ceny hurtowe',
      'moneyBack': 'Elastyczne MOQ',
      'hassleWarranty': 'Bezproblemowa gwarancja',
      'lifetimeSupport': 'Wsparcie na cały okres użytkowania',
      'subtotal': 'Suma częściowa',
      'shipping': 'Wysyłka',
      'atCheckout': 'Obliczone przy kasie',
      'taxes': 'Podatki',
      'discountApplied': 'Zastosowano rabat',
      'total': 'Razem',
      'installmentHint': 'Elastyczne opcje płatności ratalnej dostępne',
      'checkout': 'Przejdź do płatności',
      'emptyCart': 'Twój koszyk jest pusty',
      'save': 'Zapisz',
      'decreaseQty': 'Zmniejsz ilość',
      'increaseQty': 'Zwiększ ilość',
      'removeItem': 'Usuń element',
      'noRecommendations': 'Brak dostępnych rekomendacji',
      'loadRecError': 'Nie można załadować rekomendacji',
      'addedToCart': 'Element dodany do koszyka!'
    },

    'en': {
      'cartTitle': 'Shopping Cart', 'closeCart': 'Close cart',
      'haveDiscount': 'Have a discount code?', 'applyCode': 'Apply Code', 'enterDiscount': 'Enter discount code',
      'recommended': 'Recommended for You', 'shopConfidence': 'Shop with Confidence',
      'fastFreeShipping': 'Wholesale pricing', 'moneyBack': 'Flexible MOQ',
      'hassleWarranty': 'Hassle-Free Warranty', 'lifetimeSupport': 'Lifetime Support',
      'subtotal': 'Subtotal', 'shipping': 'Shipping', 'atCheckout': 'Calculated at checkout', 'taxes': 'Taxes',
      'discountApplied': 'Discount Applied', 'total': 'Total',
      'installmentHint': 'Flexible installment payment options available \u2139\ufe0f',
      'checkout': 'Proceed to Checkout', 'emptyCart': 'Your cart is empty',
      'save': 'Save', 'decreaseQty': 'Decrease quantity', 'increaseQty': 'Increase quantity', 'removeItem': 'Remove item',
      'noRecommendations': 'No recommendations available', 'loadRecError': 'Unable to load recommendations',
      'addedToCart': 'Item added to cart!'
    },
    'ar': {
      'cartTitle': 'سلة التسوق', 'closeCart': 'إغلاق السلة',
      'haveDiscount': 'هل لديك رمز خصم؟', 'applyCode': 'تطبيق الرمز', 'enterDiscount': 'أدخل رمز الخصم',
      'recommended': 'موصى به لك', 'shopConfidence': 'تسوق بثقة',
      'fastFreeShipping': 'أسعار الجملة', 'moneyBack': 'حد أدنى مرن للطلب',
      'hassleWarranty': 'ضمان بدون متاعب', 'lifetimeSupport': 'دعم مدى الحياة',
      'subtotal': 'المجموع الفرعي', 'shipping': 'الشحن', 'atCheckout': 'يُحسب عند الدفع', 'taxes': 'الضرائب',
      'discountApplied': 'الخصم المطبق', 'total': 'الإجمالي',
      'installmentHint': 'خيارات دفع مرنة متاحة ℹ️',
      'checkout': 'إتمام الدفع', 'emptyCart': 'سلتك فارغة',
      'save': 'وفّر', 'decreaseQty': 'تقليل الكمية', 'increaseQty': 'زيادة الكمية', 'removeItem': 'إزالة العنصر',
      'noRecommendations': 'لا توصيات متاحة', 'loadRecError': 'تعذر تحميل التوصيات',
      'addedToCart': 'تمت إضافة العنصر إلى السلة!'
    },
    'pt-PT': {
      'cartTitle': 'Carrinho de Compras', 'closeCart': 'Fechar carrinho',
      'haveDiscount': 'Tem um código de desconto?', 'applyCode': 'Aplicar código', 'enterDiscount': 'Insira o código de desconto',
      'recommended': 'Recomendado para você', 'shopConfidence': 'Compre com confiança',
      'fastFreeShipping': 'Preços de atacado', 'moneyBack': 'MOQ flexível',
      'hassleWarranty': 'Garantia sem complicações', 'lifetimeSupport': 'Suporte vitalício',
      'subtotal': 'Subtotal', 'shipping': 'Envio', 'atCheckout': 'Calculado no checkout', 'taxes': 'Impostos',
      'discountApplied': 'Desconto aplicado', 'total': 'Total',
      'installmentHint': 'Opções flexíveis de pagamento parcelado disponíveis ℹ️',
      'checkout': 'Finalizar compra', 'emptyCart': 'Seu carrinho está vazio',
      'save': 'Economize', 'decreaseQty': 'Diminuir quantidade', 'increaseQty': 'Aumentar quantidade', 'removeItem': 'Remover item',
      'noRecommendations': 'Nenhuma recomendação disponível', 'loadRecError': 'Não foi possível carregar recomendações',
      'addedToCart': 'Item adicionado ao carrinho!'
    },
    'fr': {
      'cartTitle': 'Panier', 'closeCart': 'Fermer le panier',
      'haveDiscount': 'Avez-vous un code de réduction ?', 'applyCode': 'Appliquer le code', 'enterDiscount': 'Saisissez le code de réduction',
      'recommended': 'Recommandé pour vous', 'shopConfidence': 'Achetez en toute confiance',
      'fastFreeShipping': 'Tarifs de gros', 'moneyBack': 'MOQ flexible',
      'hassleWarranty': 'Garantie sans tracas', 'lifetimeSupport': 'Assistance à vie',
      'subtotal': 'Sous-total', 'shipping': 'Livraison', 'atCheckout': 'Calculé à la caisse', 'taxes': 'Taxes',
      'discountApplied': 'Remise appliquée', 'total': 'Total',
      'installmentHint': 'Options de paiement flexible disponibles ℹ️',
      'checkout': 'Passer à la caisse', 'emptyCart': 'Votre panier est vide',
      'save': 'Économisez', 'decreaseQty': 'Diminuer la quantité', 'increaseQty': 'Augmenter la quantité', 'removeItem': 'Retirer l’article',
      'noRecommendations': 'Aucune recommandation disponible', 'loadRecError': 'Impossible de charger les recommandations',
      'addedToCart': 'Article ajouté au panier !'
    },
    'es': {
      'cartTitle': 'Carrito de Compras', 'closeCart': 'Cerrar carrito',
      'haveDiscount': '¿Tienes un código de descuento?', 'applyCode': 'Aplicar código', 'enterDiscount': 'Introduce el código de descuento',
      'recommended': 'Recomendado para ti', 'shopConfidence': 'Compra con confianza',
      'fastFreeShipping': 'Precios al por mayor', 'moneyBack': 'MOQ flexible',
      'hassleWarranty': 'Garantía sin complicaciones', 'lifetimeSupport': 'Soporte de por vida',
      'subtotal': 'Subtotal', 'shipping': 'Envío', 'atCheckout': 'Calculado al finalizar la compra', 'taxes': 'Impuestos',
      'discountApplied': 'Descuento aplicado', 'total': 'Total',
      'installmentHint': 'Opciones de pago flexibles disponibles ℹ️',
      'checkout': 'Finalizar compra', 'emptyCart': 'Tu carrito está vacío',
      'save': 'Ahorra', 'decreaseQty': 'Disminuir cantidad', 'increaseQty': 'Aumentar cantidad', 'removeItem': 'Eliminar artículo',
      'noRecommendations': 'No hay recomendaciones disponibles', 'loadRecError': 'No se pudieron cargar las recomendaciones',
      'addedToCart': '¡Artículo añadido al carrito!'
    },
    'de': {
      'cartTitle': 'Warenkorb', 'closeCart': 'Warenkorb schließen', 'haveDiscount': 'Haben Sie einen Rabattcode?',
      'applyCode': 'Code anwenden', 'enterDiscount': 'Rabattcode eingeben', 'recommended': 'Empfohlen für Sie',
      'shopConfidence': 'Sicher einkaufen', 'fastFreeShipping': 'Großhandelspreise', 'moneyBack': 'Flexible Mindestbestellmenge',
      'hassleWarranty': 'Problemlose Garantie', 'lifetimeSupport': 'Lebenslanger Support', 'subtotal': 'Zwischensumme',
      'shipping': 'Versand', 'atCheckout': 'Wird beim Checkout berechnet', 'taxes': 'Steuern',
      'discountApplied': 'Rabatt angewendet', 'total': 'Gesamt', 'installmentHint': 'Flexible Ratenzahlung verfügbar ℹ️',
      'checkout': 'Zur Kasse', 'emptyCart': 'Ihr Warenkorb ist leer', 'save': 'Sparen',
      'decreaseQty': 'Menge verringern', 'increaseQty': 'Menge erhöhen', 'removeItem': 'Artikel entfernen',
      'noRecommendations': 'Keine Empfehlungen verfügbar', 'loadRecError': 'Empfehlungen konnten nicht geladen werden', 'addedToCart': 'Artikel zum Warenkorb hinzugefügt!'
    },
    'it': {
      'cartTitle': 'Carrello', 'closeCart': 'Chiudi carrello', 'haveDiscount': 'Hai un codice sconto?',
      'applyCode': 'Applica codice', 'enterDiscount': 'Inserisci il codice sconto', 'recommended': 'Consigliati per te',
      'shopConfidence': 'Acquista in tutta sicurezza', 'fastFreeShipping': 'Prezzi all\'ingrosso', 'moneyBack': 'MOQ flessibile',
      'hassleWarranty': 'Garanzia senza complicazioni', 'lifetimeSupport': 'Supporto a vita', 'subtotal': 'Subtotale',
      'shipping': 'Spedizione', 'atCheckout': 'Calcolato al checkout', 'taxes': 'Tasse',
      'discountApplied': 'Sconto applicato', 'total': 'Totale', 'installmentHint': 'Opzioni di pagamento rateale flessibili disponibili ℹ️',
      'checkout': 'Vai alla cassa', 'emptyCart': 'Il tuo carrello è vuoto', 'save': 'Risparmia',
      'decreaseQty': 'Riduci quantità', 'increaseQty': 'Aumenta quantità', 'removeItem': 'Rimuovi articolo',
      'noRecommendations': 'Nessun consiglio disponibile', 'loadRecError': 'Impossibile caricare i consigli', 'addedToCart': 'Articolo aggiunto al carrello!'
    },
    'nl': {
      'cartTitle': 'Winkelwagen', 'closeCart': 'Winkelwagen sluiten', 'haveDiscount': 'Hebt u een kortingscode?',
      'applyCode': 'Code toepassen', 'enterDiscount': 'Voer kortingscode in', 'recommended': 'Aanbevolen voor u',
      'shopConfidence': 'Veilig winkelen', 'fastFreeShipping': 'Groothandelsprijzen', 'moneyBack': 'Flexibele MOQ',
      'hassleWarranty': 'Zorgeloze garantie', 'lifetimeSupport': 'Levenslange ondersteuning', 'subtotal': 'Subtotaal',
      'shipping': 'Verzending', 'atCheckout': 'Berekend bij afrekenen', 'taxes': 'Belastingen',
      'discountApplied': 'Korting toegepast', 'total': 'Totaal', 'installmentHint': 'Flexibele termijnbetalingen beschikbaar ℹ️',
      'checkout': 'Afrekenen', 'emptyCart': 'Uw winkelwagen is leeg', 'save': 'Besparen',
      'decreaseQty': 'Aantal verlagen', 'increaseQty': 'Aantal verhogen', 'removeItem': 'Artikel verwijderen',
      'noRecommendations': 'Geen aanbevelingen beschikbaar', 'loadRecError': 'Aanbevelingen konden niet worden geladen', 'addedToCart': 'Artikel toegevoegd aan winkelwagen!'
    },
  };
  function _cartLang() {
    var l = (document.documentElement.lang || 'en').toLowerCase();
    if (l.indexOf('pt') === 0) l = 'pt-PT';
    return CART_TXT[l] ? l : 'en';
  }
  function T(k) {
    return (CART_TXT[_cartLang()] && CART_TXT[_cartLang()][k]) || CART_TXT['en'][k];
  }



  

  

  // Only initialize when DOM is ready

  function init() {

    

    class AnkerCartSimple extends HTMLElement {

      constructor() {

        super();

        this.isOpen = false;

        this.cartData = null;

      }



      connectedCallback() {

        try {

          this.render();

          this.setupEvents();

          this.fetchCart();

        } catch (error) {

          console.error('❌ Error in connectedCallback:', error);

        }

      }



      render() {

        this.innerHTML = `

          <div class="anker-cart-drawer">

            <div class="anker-cart-overlay"></div>

            <div class="anker-cart-panel">

              <div class="anker-cart-header">

                <h2>${T('cartTitle')}</h2>

                <button class="anker-cart-close" aria-label="${T('closeCart')}">×</button>

              </div>

              <div class="anker-cart-body">

                <div class="anker-cart-items"></div>

                

                <!-- Discount Code Section -->

                <div class="anker-cart-discount-section">

                  <div class="anker-cart-discount-header">

                    <span>${T('haveDiscount')}</span>

                    <button class="anker-cart-apply-code-btn">${T('applyCode')}</button>

                  </div>

                  <input type="text" class="anker-cart-discode-input" placeholder="${T('enterDiscount')}">

                  <div class="anker-cart-applied-codes"></div>

                </div>

                

                <!-- Recommended Products -->

                <div class="anker-cart-recommended">

                  <h3>${T('recommended')}</h3>

                  <div class="anker-cart-recommended-products"></div>

                </div>

                

                <!-- Trust Badges -->

                <div class="anker-cart-trust-badges">

                  <h4>${T('shopConfidence')}</h4>

                  <div class="anker-cart-badge-grid">

                    <div class="anker-cart-badge">

                      <span class="badge-icon"></span>

                      <span>${T('fastFreeShipping')}</span>

                    </div>

                    <div class="anker-cart-badge">

                      <span class="badge-icon">💰</span>

                      <span>${T('moneyBack')}</span>

                    </div>

                    <div class="anker-cart-badge">

                      <span class="badge-icon">🛡️</span>

                      <span>${T('hassleWarranty')}</span>

                    </div>

                    <div class="anker-cart-badge">

                      <span class="badge-icon">♾️</span>

                      <span>${T('lifetimeSupport')}</span>

                    </div>

                  </div>

                </div>

              </div>

              

              <div class="anker-cart-footer">

                <div class="anker-cart-price-breakdown">

                  <div class="price-row">

                    <span>${T('subtotal')}</span>

                    <span class="price-value">$0.00</span>

                  </div>

                  <div class="price-row shipping">

                    <span>${T('shipping')}</span>

                    <span class="price-note">${T('atCheckout')}</span>

                  </div>

                  <div class="price-row taxes">

                    <span>${T('taxes')}</span>

                    <span class="price-note">${T('atCheckout')}</span>

                  </div>

                  <div class="price-row discount hidden">

                    <span>${T('discountApplied')}</span>

                    <span class="price-value discount-value">-$0.00</span>

                  </div>

                  <div class="price-row total">

                    <span>${T('total')}</span>

                    <span class="price-value total-price">$0.00</span>

                  </div>

                </div>

                

                <div class="anker-cart-installment-hint">

                  ${T('installmentHint')}

                </div>

                

                <a href="${(window.AEMAI_ROOT_URL||'')}/checkout" class="anker-cart-checkout-btn">${T('checkout')}</a>

              </div>

            </div>

          </div>

        `;

        this.addStyles();

      }



      addStyles() {

        const style = document.createElement('style');

        style.textContent = `

          .anker-cart-drawer{position:fixed!important;top:0!important;left:0!important;width:100%!important;height:100%!important;z-index:99999!important;pointer-events:none!important;opacity:0!important;transition:opacity .2s ease!important}

          .anker-cart-drawer.open{pointer-events:auto!important;opacity:1!important}

          .anker-cart-overlay{position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;background:rgba(0,0,0,.5)!important;opacity:0!important;transition:opacity .2s ease!important}

          .anker-cart-drawer.open .anker-cart-overlay{opacity:1!important}

          .anker-cart-panel{position:fixed!important;top:0!important;right:0!important;width:min(400px,90vw)!important;height:100vh!important;background:#060818!important;color:#f5f5f7!important;transform:translateX(100%)!important;transition:transform .2s cubic-bezier(.165,.84,.44,1)!important;display:flex!important;flex-direction:column!important;box-shadow:-4px 0 20px rgba(0,0,0,.3)!important;z-index:100000!important}

          .anker-cart-drawer.open .anker-cart-panel{transform:translateX(0)!important}

          .anker-cart-header{padding:20px!important;border-bottom:1px solid rgba(255,255,255,.1)!important;display:flex!important;justify-content:space-between!important;align-items:center!important}

          .anker-cart-header h2{margin:0!important;font-size:18px!important;font-weight:600!important;color:#f5f5f7!important}

          .anker-cart-close{background:none!important;border:none!important;color:#f5f5f7!important;font-size:28px!important;cursor:pointer!important;padding:0!important;width:32px!important;height:32px!important;display:flex!important;align-items:center!important;justify-content:center!important;transition:opacity .2s!important}

          .anker-cart-close:hover{opacity:.7!important}

          .anker-cart-body{flex:1!important;overflow-y:auto!important;padding:20px!important;display:flex!important;flex-direction:column!important;gap:24px!important}

          .anker-cart-items{display:flex!important;flex-direction:column!important;gap:16px!important}

          .anker-cart-item{display:flex!important;gap:12px!important;padding:12px!important;background:rgba(255,255,255,.05)!important;border-radius:8px!important}

          .anker-cart-item-image{width:80px!important;height:80px!important;object-fit:cover!important;border-radius:4px!important}

          .anker-cart-item-details{flex:1!important;display:flex!important;flex-direction:column!important;gap:8px!important}

          .anker-cart-item-title{font-size:14px!important;font-weight:500!important;margin:0!important;color:#f5f5f7!important;line-height:1.3!important}

          .anker-cart-item-price{font-size:14px!important;color:#a1a1a6!important;margin:0!important}

          .anker-cart-item-controls{display:flex!important;align-items:center!important;gap:8px!important;margin-top:4px!important}

          .anker-cart-qty-btn{width:28px!important;height:28px!important;border:none!important;background:rgba(255,255,255,.1)!important;color:#f5f5f7!important;border-radius:4px!important;cursor:pointer!important;font-size:16px!important;display:flex!important;align-items:center!important;justify-content:center!important;transition:background .2s!important;padding:0!important}

          .anker-cart-qty-btn:hover{background:rgba(255,255,255,.2)!important}

          .anker-cart-qty-btn:active{background:rgba(255,255,255,.3)!important}

          .anker-cart-qty{min-width:32px!important;text-align:center!important;font-size:14px!important;font-weight:500!important;color:#f5f5f7!important}

          .anker-cart-remove-btn{width:28px!important;height:28px!important;border:none!important;background:transparent!important;color:#ff4444!important;border-radius:4px!important;cursor:pointer!important;font-size:16px!important;display:flex!important;align-items:center!important;justify-content:center!important;transition:background .2s!important;padding:0!important;margin-left:auto!important}

          .anker-cart-remove-btn:hover{background:rgba(255,68,68,.1)!important}

          .anker-cart-empty{text-align:center!important;padding:40px 20px!important;color:#a1a1a6!important}

          

          /* Price Display with Compare Price - Horizontal Layout like Anker */

          .anker-cart-price-display{display:flex!important;align-items:center!important;gap:8px!important;margin:4px 0!important;flex-wrap:wrap!important}

          .anker-cart-current-price{font-size:16px!important;font-weight:700!important;color:#f5f5f7!important}

          .anker-cart-compare-price{font-size:13px!important;color:#999!important;text-decoration:line-through!important}

          .anker-cart-savings{font-size:12px!important;color:#ff6b00!important;font-weight:700!important}

          

          /* Discount Section - Hidden by default */

          .anker-cart-discount-section{display:none!important}

          .anker-cart-discount-header{display:flex!important;justify-content:space-between!important;align-items:center!important;margin-bottom:12px!important}

          .anker-cart-discount-header span{font-size:14px!important;color:#a1a1a6!important}

          .anker-cart-apply-code-btn{background:transparent!important;border:1px solid rgba(255,255,255,.3)!important;color:#f5f5f7!important;padding:6px 12px!important;border-radius:4px!important;cursor:pointer!important;font-size:12px!important;transition:all .2s!important}

          .anker-cart-apply-code-btn:hover{background:rgba(255,255,255,.1)!important;border-color:rgba(255,255,255,.5)!important}

          .anker-cart-discode-input{width:100%!important;padding:10px 12px!important;background:rgba(255,255,255,.05)!important;border:1px solid rgba(255,255,255,.2)!important;border-radius:4px!important;color:#f5f5f7!important;font-size:14px!important;outline:none!important;transition:border-color .2s!important}

          .anker-cart-discode-input:focus{border-color:rgba(255,255,255,.5)!important}

          .anker-cart-applied-codes{margin-top:12px!important;display:flex!important;flex-wrap:wrap!important;gap:8px!important}

          .anker-cart-applied-code{display:inline-flex!important;align-items:center!important;gap:6px!important;padding:6px 10px!important;background:rgba(0,255,0,.1)!important;border:1px solid rgba(0,255,0,.3)!important;border-radius:4px!important;font-size:12px!important;color:#00ff00!important}

          .anker-cart-applied-code button{background:none!important;border:none!important;color:#00ff00!important;cursor:pointer!important;font-size:14px!important;padding:0!important;width:16px!important;height:16px!important;display:flex!important;align-items:center!important;justify-content:center!important}

          

          /* Recommended Products */

          .anker-cart-recommended{border-top:1px solid rgba(255,255,255,.1)!important;padding-top:16px!important}

          .anker-cart-recommended h3{font-size:16px!important;font-weight:600!important;margin:0 0 12px 0!important;color:#f5f5f7!important}

          .anker-cart-recommended-products{display:flex!important;gap:12px!important;overflow-x:auto!important;padding-bottom:8px!important}

          .anker-cart-recommended-product{min-width:140px!important;padding:12px!important;background:rgba(255,255,255,.05)!important;border-radius:8px!important;cursor:pointer!important;transition:background .2s!important}

          .anker-cart-recommended-product:hover{background:rgba(255,255,255,.1)!important}

          .anker-cart-rec-image{width:100%!important;height:100px!important;object-fit:cover!important;border-radius:4px!important;margin-bottom:8px!important}

          .anker-cart-rec-title{font-size:12px!important;font-weight:500!important;color:#f5f5f7!important;margin:0 0 4px 0!important;display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;overflow:hidden!important}

          .anker-cart-rec-price{font-size:13px!important;font-weight:600!important;color:#f5f5f7!important}

          .anker-cart-rec-original-price{font-size:11px!important;color:#a1a1a6!important;text-decoration:line-through!important;margin-left:6px!important}

          

          /* Trust Badges */

          .anker-cart-trust-badges{border-top:1px solid rgba(255,255,255,.1)!important;padding-top:16px!important}

          .anker-cart-trust-badges h4{font-size:14px!important;font-weight:600!important;margin:0 0 12px 0!important;color:#f5f5f7!important}

          .anker-cart-badge-grid{display:grid!important;grid-template-columns:repeat(2,1fr)!important;gap:12px!important}

          .anker-cart-badge{display:flex!important;align-items:center!important;gap:8px!important;padding:10px!important;background:rgba(255,255,255,.03)!important;border-radius:6px!important;font-size:11px!important;color:#a1a1a6!important}

          .badge-icon{font-size:16px!important}

          

          /* Footer & Price Breakdown */

          .anker-cart-footer{padding:20px!important;border-top:1px solid rgba(255,255,255,.1)!important;background:rgba(0,0,0,.2)!important}

          .anker-cart-price-breakdown{margin-bottom:16px!important}

          .price-row{display:flex!important;justify-content:space-between!important;padding:8px 0!important;font-size:14px!important;color:#a1a1a6!important}

          .price-row.total{border-top:1px solid rgba(255,255,255,.2)!important;padding-top:12px!important;margin-top:8px!important;font-size:18px!important;font-weight:600!important;color:#f5f5f7!important}

          .price-value{color:#f5f5f7!important;font-weight:500!important}

          .price-note{color:#666!important;font-style:italic!important;font-size:12px!important}

          .discount-value{color:#00ff00!important}

          .hidden{display:none!important}

          

          .anker-cart-installment-hint{text-align:center!important;font-size:11px!important;color:#666!important;margin-bottom:12px!important}

          .anker-cart-checkout-btn{display:block!important;width:100%!important;padding:16px!important;background:#007bff!important;color:#fff!important;text-align:center!important;text-decoration:none!important;border-radius:8px!important;font-weight:600!important;font-size:16px!important;transition:all .2s!important;border:none!important;cursor:pointer!important}

          .anker-cart-checkout-btn:hover{background:#0056b3!important}

        `;

        this.appendChild(style);

      }



      setupEvents() {

        try {

          const closeBtn = this.querySelector('.anker-cart-close');

          if (closeBtn) closeBtn.addEventListener('click', () => this.close());

          

          const overlay = this.querySelector('.anker-cart-overlay');

          if (overlay) overlay.addEventListener('click', () => this.close());

          

          document.addEventListener('keydown', (e) => {

            if (e.key === 'Escape' && this.isOpen) this.close();

          });

          

          document.addEventListener('anker-cart:open', () => this.open());

          document.addEventListener('cart:updated', () => this.fetchCart());

          

          // Intercept all cart links to open drawer instead of navigating

          this.interceptCartLinks();

          

          // Intercept Add to Cart forms to prevent page navigation

          this.interceptAddToCartForms();

          

        } catch (error) {

          console.error(' Error setting up events:', error);

        }

      }

      

      interceptAddToCartForms() {

        // Find all "Add to Cart" forms and intercept their submission

        const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');

        

        addToCartForms.forEach(form => {

          form.addEventListener('submit', async (e) => {

            e.preventDefault(); // Prevent default form submission (page navigation)

            e.stopPropagation();

            



            try {

              // Get form data

              const formData = new FormData(form);

              

              // Submit via AJAX

              const response = await fetch('/cart/add.js', {

                method: 'POST',

                body: formData

              });

              

              if (!response.ok) throw new Error('Failed to add item to cart');

              

              const cartData = await response.json();



              // Update badge counter

              this.updateBadgeCounter();

              

              // Trigger global cart update event

              document.dispatchEvent(new CustomEvent('cart:updated'));

              

              // Optionally show a notification (you can customize this)

              this.showNotification(T('addedToCart'));

              

            } catch (error) {

              console.error('❌ Error adding item to cart:', error);

              // If AJAX fails, allow default behavior as fallback

              form.submit();

            }

          });

        });

        

      }

      

      updateBadgeCounter() {

        // Update the cart badge in the header

        fetch('/cart.js')

          .then(res => res.json())

          .then(cart => {

            const itemCount = cart.item_count;

            const badges = document.querySelectorAll('.header__icon--cart .badge-count, [data-cart-count], .cart-count');

            

            badges.forEach(badge => {

              badge.textContent = itemCount > 0 ? itemCount : '';

              badge.style.display = itemCount > 0 ? 'inline-block' : 'none';

            });

            

          })

          .catch(err => console.error('❌ Error updating badge:', err));

      }

      

      showNotification(message) {

        // Create a simple notification toast

        const notification = document.createElement('div');

        notification.className = 'anker-cart-notification';

        notification.textContent = message;

        notification.style.cssText = `

          position: fixed !important;

          bottom: 20px !important;

          right: 20px !important;

          background: #060818 !important;

          color: #f5f5f7 !important;

          padding: 16px 24px !important;

          border-radius: 8px !important;

          box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;

          z-index: 999999 !important;

          font-size: 14px !important;

          animation: slideIn 0.3s ease !important;

        `;

        

        document.body.appendChild(notification);

        

        // Remove after 3 seconds

        setTimeout(() => {

          notification.style.animation = 'slideOut 0.3s ease';

          setTimeout(() => notification.remove(), 300);

        }, 3000);

        

      }

      

      interceptCartLinks() {

        // Find all links that point to /cart and intercept them

        const cartLinks = document.querySelectorAll('a[href*="/cart"], a[href$="/cart"]');

        cartLinks.forEach(link => {

          link.addEventListener('click', (e) => {

            e.preventDefault(); // Prevent navigation

            e.stopPropagation();

            this.open();

          });

        });

        

        // Also use event delegation for dynamically added links

        document.addEventListener('click', (e) => {

          const link = e.target.closest('a[href*="/cart"], a[href$="/cart"]');

          if (link && !link.classList.contains('anker-cart-checkout-btn')) {

            e.preventDefault();

            e.stopPropagation();

            this.open();

          }

        });

        

      }



      open() {

        this.isOpen = true;

        const drawer = this.querySelector('.anker-cart-drawer');

        if (drawer) drawer.classList.add('open');

        document.body.style.overflow = 'hidden';

        this.fetchCart();

      }



      close() {

        this.isOpen = false;

        const drawer = this.querySelector('.anker-cart-drawer');

        if (drawer) drawer.classList.remove('open');

        document.body.style.overflow = '';

      }



      async fetchCart() {

        try {

          const response = await fetch('/cart.js');

          if (!response.ok) throw new Error('Failed to fetch cart');

          this.cartData = await response.json();
          if (typeof this.loadRecommendedProducts === 'function') this.loadRecommendedProducts();



          // Fetch product details to get compare_at_price

          await this.fetchProductDetails();

          

          this.renderCartItems();

        } catch (error) {

          console.error(' Error fetching cart:', error);

        }

      }

      

      async fetchProductDetails() {

        if (!this.cartData || !this.cartData.items || this.cartData.items.length === 0) return;

        

        try {

          // Get unique product handles from cart items

          const handles = [...new Set(this.cartData.items.map(item => item.handle))];



          // Fetch product details for each handle

          const productPromises = handles.map(handle => 

            fetch(`/products/${handle}.js`).then(res => res.json())

          );

          

          const products = await Promise.all(productPromises);

          



          // Create a map of variant_id -> compare_at_price (store as-is from API)

          this.variantPrices = {};

          products.forEach((product, idx) => {

            if (product && product.variants) {

              product.variants.forEach(variant => {

                const priceNum = parseFloat(variant.price);

                const comparePriceNum = parseFloat(variant.compare_at_price);

                

                if (comparePriceNum && comparePriceNum > priceNum) {

                  // Use STRING key to match cart item variant_id

                  this.variantPrices[String(variant.id)] = comparePriceNum;

                }

              });

            }

          });

          

        } catch (error) {

          console.error('❌ Error fetching product details:', error);

        }

      }



      renderCartItems() {

        const container = this.querySelector('.anker-cart-items');

        if (!container || !this.cartData) return;

        

        // Update price breakdown

        this.updatePriceBreakdown();

        

        // Empty cart message

        if (this.cartData.items.length === 0) {

          container.innerHTML = '<div class="anker-cart-empty"><p>' + T('emptyCart') + '</p></div>';

          // Hide other sections when cart is empty

          const discountSection = this.querySelector('.anker-cart-discount-section');

          const recommended = this.querySelector('.anker-cart-recommended');

          const trustBadges = this.querySelector('.anker-cart-trust-badges');

          if (discountSection) discountSection.style.display = 'none';

          if (recommended) recommended.style.display = 'none';

          if (trustBadges) trustBadges.style.display = 'none';

          return;

        }

        

        // Hide discount section (not needed for now)

        const discountSection = this.querySelector('.anker-cart-discount-section');

        if (discountSection) discountSection.style.display = 'none';

        

        // Show sections when cart has items

        const recommended = this.querySelector('.anker-cart-recommended');

        const trustBadges = this.querySelector('.anker-cart-trust-badges');

        if (recommended) recommended.style.display = 'block';

        if (trustBadges) trustBadges.style.display = 'block';

        

        // Render items with quantity controls, delete button, and price display (Anker-style)

        container.innerHTML = this.cartData.items.map(item => {

          const currentPrice = item.price / 100;

          // Use compare_at_price from product details - divide by 100 to convert from cents to dollars

          const variantKey = String(item.variant_id);

          const comparePriceCents = this.variantPrices && this.variantPrices[variantKey];

          const comparePrice = comparePriceCents ? comparePriceCents / 100 : null;

          const savings = comparePrice && comparePrice > currentPrice ? (comparePrice - currentPrice) * item.quantity : 0;

          



          return `

            <div class="anker-cart-item" data-key="${item.key}">

              <img src="${item.image}" alt="${item.title}" class="anker-cart-item-image">

              <div class="anker-cart-item-details">

                <h3 class="anker-cart-item-title">${item.title}</h3>

                <div class="anker-cart-price-display">

                  ${comparePrice && comparePrice > currentPrice ? `

                    <span class="anker-cart-current-price">$${currentPrice.toFixed(2)}</span>

                    <span class="anker-cart-compare-price">$${comparePrice.toFixed(2)}</span>

                    <span class="anker-cart-savings">${T('save')} $${savings.toFixed(2)}</span>

                  ` : `

                    <span class="anker-cart-current-price">$${currentPrice.toFixed(2)}</span>

                  `}

                </div>

                <div class="anker-cart-item-controls">

                  <button class="anker-cart-qty-btn minus" data-key="${item.key}" aria-label="${T('decreaseQty')}">−</button>

                  <span class="anker-cart-qty">${item.quantity}</span>

                  <button class="anker-cart-qty-btn plus" data-key="${item.key}" aria-label="${T('increaseQty')}">+</button>

                  <button class="anker-cart-remove-btn" data-key="${item.key}" aria-label="${T('removeItem')}">🗑️</button>

                </div>

              </div>

            </div>

          `;

        }).join('');

        

        // Add event listeners for quantity controls

        this.setupQuantityControls();

        

        // Load recommended products

        this.loadRecommendedProducts();

        

      }

      

      updatePriceBreakdown() {

        if (!this.cartData) return;

        

        const subtotal = this.cartData.total_price / 100;

        const totalPriceEl = this.querySelector('.total-price');

        const priceValueEls = this.querySelectorAll('.price-value:not(.total-price):not(.discount-value)');

        

        // Update subtotal

        if (priceValueEls[0]) {

          priceValueEls[0].textContent = `$${subtotal.toFixed(2)}`;

        }

        

        // Update total

        if (totalPriceEl) {

          totalPriceEl.textContent = `$${subtotal.toFixed(2)}`;

        }

        

        // Handle discounts (if any)

        const discountRow = this.querySelector('.price-row.discount');

        const discountValue = this.querySelector('.discount-value');

        if (this.cartData.total_discount > 0 && discountRow && discountValue) {

          const discount = this.cartData.total_discount / 100;

          discountValue.textContent = `-$${discount.toFixed(2)}`;

          discountRow.classList.remove('hidden');

          

          // Adjust total

          const finalTotal = subtotal - discount;

          if (totalPriceEl) {

            totalPriceEl.textContent = `$${finalTotal.toFixed(2)}`;

          }

        } else if (discountRow) {

          discountRow.classList.add('hidden');

        }

      }

      

      async loadRecommendedProducts() {

        const container = this.querySelector('.anker-cart-recommended-products');

        if (!container) return;

        

        try {

          // Fetch featured products from Shopify

          const response = await fetch('/collections/aemai-retail-products/products.json?limit=4');

          if (!response.ok) throw new Error('Failed to fetch products');

          

          const data = await response.json();

          const products = data.products || [];

          

          // Filter out products already in cart

          const cartItemIds = this.cartData.items.map(item => item.product_id);

          const recommended = products.filter(p => !cartItemIds.includes(p.id)).filter(p => !/(Wholesale|Bundle|Gift Set)/i.test(p.title)).slice(0, 4);

          

          if (recommended.length === 0) {

            container.innerHTML = '<p style="color:#666;font-size:12px;">' + T('noRecommendations') + '</p>';

            return;

          }

          

          container.innerHTML = recommended.map(product => {

            const variant = product.variants[0];

            // Shopify products.json returns price in dollars (not cents)

            const price = variant ? parseFloat(variant.price) : 0;
            const isWholesale = /(Wholesale|Bundle|Gift Set)/i.test(product.title);

            const comparePrice = variant && variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;

            

            return `

              <div class="anker-cart-recommended-product" onclick="window.location.href='/products/${product.handle}'">

                <img src="${product.images[0]?.src || ''}" alt="${product.title}" class="anker-cart-rec-image">

                <h4 class="anker-cart-rec-title">${product.title}</h4>

                <div>

                  ${isWholesale ? '<span class="anker-cart-rec-price" style="color:var(--aemai-primary)!important;">Wholesale Only</span>' : '<span class="anker-cart-rec-price">$' + price.toFixed(2) + '</span>'}

                  ${comparePrice && comparePrice > price ? '<span class="anker-cart-rec-original-price">$' + comparePrice.toFixed(2) + '</span>' : ''}

                </div>

              </div>

            `;

          }).join('');

          

        } catch (error) {

          console.error('❌ Error loading recommended products:', error);

          container.innerHTML = '<p style="color:#666;font-size:12px;">' + T('loadRecError') + '</p>';

        }

      }

      

      setupQuantityControls() {

        // Quantity + buttons

        this.querySelectorAll('.anker-cart-qty-btn.plus').forEach(btn => {

          btn.addEventListener('click', async (e) => {

            const key = e.target.dataset.key;

            await this.updateQuantity(key, 1);

          });

        });

        

        // Quantity - buttons

        this.querySelectorAll('.anker-cart-qty-btn.minus').forEach(btn => {

          btn.addEventListener('click', async (e) => {

            const key = e.target.dataset.key;

            await this.updateQuantity(key, -1);

          });

        });

        

        // Remove buttons

        this.querySelectorAll('.anker-cart-remove-btn').forEach(btn => {

          btn.addEventListener('click', async (e) => {

            const key = e.target.dataset.key;

            await this.removeItem(key);

          });

        });

        

      }

      

      async updateQuantity(key, delta) {

        try {



          // Find current quantity

          const item = this.cartData.items.find(i => i.key === key);

          if (!item) return;

          

          const newQty = Math.max(1, item.quantity + delta);

          

          // Call Shopify Cart API

          const response = await fetch('/cart/change.js', {

            method: 'POST',

            headers: { 'Content-Type': 'application/json' },

            body: JSON.stringify({ id: key, quantity: newQty })

          });

          

          if (!response.ok) throw new Error('Failed to update quantity');

          

          // Refresh cart data

          await this.fetchCart();

          

          // Trigger global cart update event

          document.dispatchEvent(new CustomEvent('cart:updated'));

          

        } catch (error) {

          console.error('❌ Error updating quantity:', error);

        }

      }

      

      async removeItem(key) {

        try {



          // Call Shopify Cart API to remove item

          const response = await fetch('/cart/change.js', {

            method: 'POST',

            headers: { 'Content-Type': 'application/json' },

            body: JSON.stringify({ id: key, quantity: 0 })

          });

          

          if (!response.ok) throw new Error('Failed to remove item');

          

          // Refresh cart data

          await this.fetchCart();

          

          // Trigger global cart update event

          document.dispatchEvent(new CustomEvent('cart:updated'));

          

        } catch (error) {

          console.error('❌ Error removing item:', error);

        }

      }

    }



    if (!customElements.get('anker-cart-simple')) {

      customElements.define('anker-cart-simple', AnkerCartSimple);

    }

  }

  

  // Wait for DOM ready

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();

